export const INITIAL_STATE = {
  data: {
    events: [],
    eventsLoading: true,
    channels: [],
    subscriptions: [],
    subscribeOptions: {
      subscribeLoading: false,
      error: false,
      messageType: null
    },
    chats: {},
    allChats: [],
    messageNotification: {
      newMessages: false,
      count: 0
    }
  },
  user: {
    uid: '',
    userClaims: {},
    userData: {},
    savedEvents: [],
    favoriteChats: [],
    saveLoadingOptions: {
      favoritesChatLoading: false,
      saveLoading: false,
      error: false,
      messageType: null
    }
  },
  options: {}
};



// WEBPACK FOOTER //
// ./src/constants/InitialState.js